require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./journal-livinf-etc-bathroom-trends-2020.json") })
        }
      }, "path---journal-livinf-etc-bathroom-trends-2020");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---journal-livinf-etc-bathroom-trends-2020!./.cache/json/journal-livinf-etc-bathroom-trends-2020.json
// module id = 510
// module chunks = 231608221292675